import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import FoundationApp from './FoundationApp';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<FoundationApp />);
